import { useAppState } from "AppState";
import React, { useContext } from "react";
import { Routes } from "router";

import { TabletDataContext } from "components/Gates/TabletDataGate";
import { shouldHideUsageType } from "components/UsageTypeSelector/utils";

import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import TermsAndConditions from "screens/Onboarding/WelcomeBoard/TermsAndConditions/TermsAndConditions";
import useReactRouter from "use-react-router";

export default (): JSX.Element => {
  const { locationName, availableInterests } = useAppState();
  const { history } = useReactRouter();
  const tabletData = useContext(TabletDataContext);
  const { logoutCustomer } = OnboardingContainer.useContainer();

  const goToSignUpUsageTypeSelection = () =>
    history.push(Routes.SignUpUsageTypeSelection);

  const goToSignUpInterestSelection = () =>
    history.push(Routes.SignUpInterestSelection);
  const goToSignUpCustomerPersonalInfo = () =>
    history.push(Routes.SignUpCustomerPersonalInfo);

  const goToSignUp = () => {
    logoutCustomer();
    history.push(Routes.Home);
  };

  return (
    <TermsAndConditions
      locationName={locationName}
      nextStep={
        shouldHideUsageType(tabletData)
          ? tabletData && tabletData.hasNoInterests
            ? goToSignUpCustomerPersonalInfo
            : goToSignUpInterestSelection
          : goToSignUpUsageTypeSelection
      }
      previousStep={goToSignUp}
    />
  );
};



// WEBPACK FOOTER //
// ./src/screens/Onboarding/SignUp/TcpaAcknowledgement/TcpaAcknowledgement.tsx